module.exports = __webpack_public_path__ + "img/2-en.81f3dd13.png";